import styled from 'styled-components';
import Dropdown from '../../../CoreWrappers/Dropdown';

export default styled(Dropdown)`
	--size: var(--spacing-x-large);
	--gap: var(--spacing-x-large);
	--max-height: 70vh;
	--min-height: 50vh;
	position: relative;
	display: flex;
	align-items: center;
	.motif-dropdown-menu {
		width: var(--px-400);
		min-width: unset;
		.customScrollbar {
			overflow-x: hidden;
		}
	}
`;
